import clsx from "clsx"
import type { ReactNode } from "react"

import { Text } from "../Text"
import styles from "./FieldSet.module.css"

type Variant = "normal" | "compact"

export interface FieldSetProps {
  children?: ReactNode
  selected?: boolean
  id?: string
  legend: string
  name?: string
  onFocus?: () => void
  /**
   * Additional content to be displayed in the header.
   */
  header?: ReactNode
  variant?: Variant
}

export function FieldSet(props: FieldSetProps) {
  const {
    selected,
    children,
    legend,
    id,
    name,
    onFocus,
    header,
    variant = "normal",
  } = props

  return (
    <fieldset
      className={clsx(
        styles.fieldSet,
        styles[`variant-${variant}`],
        getBorderClassName(variant, selected),
      )}
      id={id}
      name={name}
      onFocus={onFocus}
    >
      <header className={styles.legend}>
        <Text
          component="span"
          variant={getLegendVariant(variant)}
          color={getLegendColor(variant)}
        >
          {legend}
        </Text>
        {header}
      </header>
      <div className={styles.fieldSetContent}>{children}</div>
    </fieldset>
  )
}

function getBorderClassName(variant: Variant, selected: boolean | undefined) {
  if (selected) return styles["border-selected"]
  return styles[`border-${variant}`]
}

function getLegendVariant(variant: Variant) {
  switch (variant) {
    case "normal":
      return "smallBold"
    case "compact":
      return "extraSmall"
  }
}

function getLegendColor(variant: Variant) {
  switch (variant) {
    case "normal":
      return "grey12"
    case "compact":
      return "grey11"
  }
}
